<!-- Pantalla 1: la tabla de generaciones -->
<ng-container *ngIf="!abierta">
<!-- Cabecera: subida automática y botón «Generar» -->
<div class="od-toolbar">
  <span class="od-muted" *ngIf="cabecera">{{ cabecera }}</span>
  <span class="od-gen-filtro">
    <label class="od-input"><span class="od-muted">Desde</span><input type="date" [(ngModel)]="filtroDesde" (ngModelChange)="cambioFiltro()" aria-label="Filtrar desde"></label>
    <label class="od-input"><span class="od-muted">Hasta</span><input type="date" [(ngModel)]="filtroHasta" (ngModelChange)="cambioFiltro()" aria-label="Filtrar hasta"></label>
    <label class="od-input"><span class="od-muted">Estado</span>
      <select [(ngModel)]="filtroEstado" (ngModelChange)="cambioFiltro()" aria-label="Filtrar por estado"><option *ngFor="let e of estados; trackBy: porValor" [ngValue]="e.valor">{{ e.texto }}</option></select>
    </label>
    <button type="button" class="od-btn od-btn-sm od-btn-ghost" *ngIf="hayFiltro" (click)="limpiarFiltro()">Limpiar</button>
  </span>
  <span class="od-fin" style="display:inline-flex;gap:8px;align-items:center">
    <button type="button" class="od-btn" (click)="recargar()" title="Volver a consultar" aria-label="Volver a consultar"><od-icon name="refresh"></od-icon></button>
    <button type="button" class="od-btn od-btn-primary" *ngIf="puedeEditar" (click)="abrirModal()"><od-icon name="file"></od-icon>Generar</button>
  </span>
</div>

<p class="od-gen-filtro-error" *ngIf="filtroError" role="alert">{{ filtroError }}</p>

<!-- Avisos: qué hay que atender (rojo) o vigilar (ámbar) -->
<div class="od-alert" [ngClass]="a.rojo ? 'od-alert-mal' : 'od-gen-ambar'" *ngFor="let a of avisos; trackBy: porIndice" role="alert">
  <od-icon name="alert" [size]="16"></od-icon>
  <div class="od-alert-tx">{{ a.mensaje }}</div>
  <button type="button" class="od-btn od-btn-sm" *ngIf="a.accion === 'Ver' || puedeEditar" (click)="atender(a)">{{ a.accion }}</button>
</div>

<!-- Error al traer la lista -->
<div class="od-alert" *ngIf="error" role="alert">
  <od-icon name="alert" [size]="16"></od-icon>
  <div class="od-alert-tx"><b>No se pudo traer la lista de archivos.</b> {{ error }}</div>
  <button type="button" class="od-btn od-btn-sm" (click)="recargar()">Reintentar</button>
</div>

<!-- Cargando -->
<div *ngIf="cargando && !filas.length && !error" aria-busy="true">
  <div class="od-skeleton" style="height:44px;margin-bottom:6px" *ngFor="let i of esperando; trackBy: porIndice"></div>
</div>

<div class="od-empty" *ngIf="!cargando && !error && !filtroError && !filas.length && hayFiltro">
  <od-icon name="file" [size]="28"></od-icon>
  <b>No hay generaciones en esas fechas</b>
</div>
<div class="od-empty" *ngIf="!cargando && !error && !filtroError && !filas.length && !hayFiltro">
  <od-icon name="file" [size]="28"></od-icon>
  <b>Todavía no hay archivos generados</b>
  <span>Pulsa «Generar» para crear los archivos de giros y pagos de un rango de fechas.</span>
</div>

<ng-container *ngIf="filas.length">
  <div class="od-table-wrap od-gen-wrap" [style.opacity]="cargando ? .6 : 1">
    <table class="od-table od-gen-tabla">
      <thead>
        <tr><th>Rango</th><th>Giros</th><th>Pagos</th><th>Estado</th><th style="text-align:right">Acciones</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let f of filas; trackBy: porId">
          <td data-et="Rango"><b>{{ f.rango }}</b></td>
          <td data-et="Giros">{{ f.giros }}</td>
          <td data-et="Pagos"><span>{{ f.pagos }}<span class="od-muted" style="display:block;font-size:12px" *ngIf="f.duplicados">{{ f.duplicados }}</span></span></td>
          <td data-et="Estado">
            <span style="display:inline-flex;flex-direction:column;gap:4px;align-items:flex-start">
              <span class="od-badge" [ngClass]="'od-badge-' + f.tipoChip">{{ f.chip }}</span>
              <span class="od-gen-avance" *ngIf="f.estado === 'generando'" role="progressbar" [attr.aria-valuenow]="f.pct" aria-valuemin="0" aria-valuemax="100" [attr.aria-label]="f.avance">
                <span class="od-bar"><i [style.width.%]="f.pct"></i></span><span class="od-gen-pct">{{ f.pct }} %</span>
              </span>
              <span class="od-muted" style="font-size:12px;display:inline-flex;gap:4px;align-items:center" *ngIf="f.automatico"><od-icon name="clock" [size]="12"></od-icon>automático</span>
              <span class="od-gen-motivo" *ngIf="motivos[f.id] || f.motivo" [title]="motivos[f.id] || f.motivo">{{ motivos[f.id] || f.motivo }}</span>
            </span>
          </td>
          <td class="od-gen-ac" style="text-align:right">
            <span class="od-gen-acciones">
              <button type="button" class="od-btn od-btn-sm od-btn-ghost" [disabled]="f.estado === 'generando'" (click)="ver(f.id)" [attr.aria-label]="'Ver la generación del ' + f.rango">
                <od-icon name="eye" [size]="14"></od-icon>Ver
              </button>
              <button type="button" class="od-btn od-btn-sm od-btn-primary" *ngIf="puedeEditar && ((f.estado === 'error' && !f.envioFallido) || f.estado === 'interrumpido')" [disabled]="!!reintentando" (click)="reintentar(f)">
                <od-icon name="refresh" [size]="14" [class.od-spin]="reintentando === f.id"></od-icon>Reintentar
              </button>
              <button type="button" class="od-btn od-btn-sm od-btn-primary" *ngIf="puedeEditar && f.envioFallido" (click)="ver(f.id)"><od-icon name="upload" [size]="14"></od-icon>Enviar lo que falta</button>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <od-paginador [page]="page" [limit]="limite" [total]="total" unidad="generaciones" (cambiar)="ir($event)"></od-paginador>
</ng-container>
</ng-container>

<!-- Modal «Generar archivos» -->
<div class="od-dialog-fondo" *ngIf="modal as m" (click)="cerrarModal()">
  <div #dlg class="od-dialog od-gen-dlg" role="dialog" aria-modal="true" aria-labelledby="odGenTitulo" (click)="$event.stopPropagation()" (keydown)="atrapar($event, dlg)">
    <button type="button" class="od-btn od-btn-sm od-btn-ghost od-gen-x" (click)="cerrarModal()" aria-label="Cerrar"><od-icon name="x" [size]="16"></od-icon></button>
    <h4 id="odGenTitulo" style="font-size:16px;font-weight:600">Generar archivos</h4>
    <p class="od-muted" style="font-size:13px;margin-top:4px">Giros y pagos</p>

    <!-- Paso 1: elegir el rango -->
    <ng-container *ngIf="!m.id">
      <div class="od-gen-campos" style="margin-top:12px">
        <label>Desde
          <span class="od-input"><od-icon name="cal"></od-icon><input #campoDesde type="date" [(ngModel)]="m.desde" [max]="maxFecha" (ngModelChange)="cambioFecha()" aria-label="Desde"></span>
        </label>
        <label>Hasta
          <span class="od-input"><od-icon name="cal"></od-icon><input type="date" [(ngModel)]="m.hasta" [max]="maxFecha" (ngModelChange)="cambioFecha()" aria-label="Hasta"></span>
        </label>
      </div>
      <p class="od-note">Un solo archivo de giros y uno de pagos para todo el rango.</p>

      <div class="od-alert od-gen-ambar" *ngIf="m.enviados.length" role="alert">
        <od-icon name="alert" [size]="16"></od-icon>
        <div class="od-alert-tx">
          <b>Estos días ya se enviaron a 3MIT: {{ enviadosTexto }}.</b> 3MIT rechazaría las filas repetidas.
          <div style="margin-top:8px" *ngIf="siguienteDelUltimo">
            <button type="button" class="od-btn od-btn-sm" (click)="empezarDespues()">Empezar después del último enviado</button>
          </div>
        </div>
      </div>
      <p class="od-muted" style="font-size:13px;color:var(--od-danger)" *ngIf="rangoError" role="alert">{{ rangoError }}</p>
      <div class="od-alert od-alert-mal" *ngIf="m.error" role="alert"><od-icon name="alert" [size]="16"></od-icon><div class="od-alert-tx">{{ m.error }}</div></div>

      <div class="od-dialog-pie">
        <button type="button" class="od-btn" (click)="cerrarModal()">Cancelar</button>
        <button type="button" class="od-btn od-btn-primary" [disabled]="!!rangoError || m.creando" (click)="generar()">{{ m.creando ? 'Generando…' : 'Generar' }}</button>
      </div>
    </ng-container>

    <!-- Paso 2: avance y resumen -->
    <ng-container *ngIf="m.id">
      <div style="margin-top:14px" *ngIf="!modalTerminado" aria-live="polite">
        <p style="font-size:14px;font-weight:500">{{ m.avance }}</p>
        <div class="od-gen-avance" style="margin-top:8px" role="progressbar" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="m.gen?.progreso?.pct || 0" [attr.aria-label]="m.avance">
          <span class="od-bar"><i [style.width.%]="m.gen?.progreso?.pct || 0"></i></span><span class="od-gen-pct">{{ m.gen?.progreso?.pct || 0 }} %</span>
        </div>
        <p class="od-note">Sigue generando en segundo plano; lo verás en la tabla.</p>
      </div>

      <ng-container *ngIf="modalTerminado">
        <div class="od-alert od-alert-mal" *ngIf="modalFallo" role="alert" style="margin-top:12px"><od-icon name="alert" [size]="16"></od-icon><div class="od-alert-tx">{{ modalFallo }}</div></div>
        <section class="od-sec" style="margin-top:12px" *ngIf="m.resumen as r">
          <div class="od-srow"><span class="od-tx"><b>Giros</b></span><span>{{ r.giros }}</span></div>
          <div class="od-srow"><span class="od-tx"><b>Pagos</b></span><span>{{ r.pagos }}</span></div>
          <div class="od-srow" *ngIf="r.duplicados > 0"><span class="od-tx"><b>Duplicados omitidos</b></span><span>{{ r.duplicados }}</span></div>
          <div class="od-srow"><span class="od-tx"><b>Revisión</b></span>
            <span class="od-badge" [ngClass]="r.conProblemas ? 'od-badge-problem' : 'od-badge-solid'">{{ r.problemas }}</span>
          </div>
        </section>
        <div class="od-dialog-pie">
          <button type="button" class="od-btn" (click)="cerrarModal()">Cerrar</button>
          <button type="button" class="od-btn od-btn-primary" (click)="verDesdeModal()"><od-icon name="eye" [size]="14"></od-icon>Ver</button>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<!-- Pantalla 2: el detalle de una generación (?gen=<id>) -->
<app-odoo-generacion *ngIf="abierta as id" [id]="id" [puedeEditar]="puedeEditar" [consolaUrl]="consolaUrl" (volver)="volver()"></app-odoo-generacion>
